import React, { FC, useCallback, useEffect, useState } from "react"
import styles from "@/components/styles/video.module.css"
import BtnList from "@/components/btnList"
import Text from "@/components/text"
import BuyCardV2 from "./buyCardV2"
import { useNavigate } from "react-router-dom"
import { encode, } from 'js-base64';
import u, { ELocalKey } from "@/util"
import Img from "@/components/img"
import { appendHost } from "@/const/append";
import copy from "copy-to-clipboard"
import useConfBase from "@/hooks/useConfBase"
// import VideoPlayer from "./videoPlayer"
import DPlayer from 'dplayer';
import { EModalTypes, modalSubject$ } from "@/hooks/useModal"
import Fenxiang from "@/components/svg/fenxiang"
import Xiazai from "@/components/svg/xiazai"
import Yingpian from "@/components/svg/yingpian"
import moment from "moment";
import useWindowDimensions from "@/hooks/useDimension"
import { useParams } from "react-router-dom";
import Comment from "@/components/commentList";


var sprintf = require('sprintf-js').sprintf;

interface IVideo {
    title: string;
    vidurl: string;
    sourceurl: string;
    data: any;
    hideMiddle?: boolean;
    tag?: React.ReactNode;
    hideBuyCard?: boolean;
    relatedVidList?: any;
    likeVidList?: any;
    otherList?: any;

}

enum DPlayerEvents {
    abort = 'abort',
    canplay = 'canplay',
    canplaythrough = 'canplaythrough',
    durationchange = 'durationchange',
    emptied = 'emptied',
    ended = 'ended',
    error = 'error',
    loadeddata = 'loadeddata',
    loadedmetadata = 'loadedmetadata',
    loadstart = 'loadstart',
    mozaudioavailable = 'mozaudioavailable',
    pause = 'pause',
    play = 'play',
    playing = 'playing',
    progress = 'progress',
    ratechange = 'ratechange',
    seeked = 'seeked',
    seeking = 'seeking',
    stalled = 'stalled',
    suspend = 'suspend',
    timeupdate = 'timeupdate',
    volumechange = 'volumechange',
    waiting = 'waiting',
    screenshot = 'screenshot',
    thumbnails_show = 'thumbnails_show',
    thumbnails_hide = 'thumbnails_hide',
    danmaku_show = 'danmaku_show',
    danmaku_hide = 'danmaku_hide',
    danmaku_clear = 'danmaku_clear',
    danmaku_loaded = 'danmaku_loaded',
    danmaku_send = 'danmaku_send',
    danmaku_opacity = 'danmaku_opacity',
    contextmenu_show = 'contextmenu_show',
    contextmenu_hide = 'contextmenu_hide',
    notice_show = 'notice_show',
    notice_hide = 'notice_hide',
    quality_start = 'quality_start',
    quality_end = 'quality_end',
    destroy = 'destroy',
    resize = 'resize',
    fullscreen = 'fullscreen',
    fullscreen_cancel = 'fullscreen_cancel',
    subtitle_show = 'subtitle_show',
    subtitle_hide = 'subtitle_hide',
    subtitle_change = 'subtitle_change'
}

const Video: FC<IVideo> = ({ title, vidurl, sourceurl, data, hideMiddle, tag, hideBuyCard, relatedVidList, likeVidList, otherList }) => {
    const [config, updateConfig, getData] = useConfBase();
    const navigate = useNavigate()
    const [footAds, setFootAds] = useState<any[]>([])
    const [source, setSource] = useState<string>("")
    const [encryptUrls, setEncryptUrls] = useState<string[]>([])
    const [encryptUrlsLike, setEncryptUrlsLike] = useState<string[]>([])
    const [vidList, setVidList] = useState<string[]>([])
    const [vidLikeList, setVidLikeList] = useState<string[]>([])
    const [List, setotherList] = useState<string[]>([])
    const [selectedTab, setSelectedTab] = useState<any>()
    const [showImg, setShowImg] = useState<any>("")
    const [isMobile, setIsMobile] = useState(false);
    const [commentList, setCommentList] = useState<any>()
    const [error, setError] = useState<string | null>(null);   // Store error if any



    const { channel, id } = useParams()


    const commentArray = commentList?.list;
    const player_assistant = otherList?.ads.player_assistant;
    const player_banner = otherList?.ads.player_banner;
    const player_mobile = otherList?.ads.player_mobile;
    const player_theme_1 = otherList?.ads.player_theme_1;
    const player_theme_2 = otherList?.ads.player_theme_2;
    const player_video_recommendation = otherList?.ads.player_video_recommendation;
    const access_no_vpn = otherList?.config.player_config_1.player_config2_access_no_vpn;
    const benefit = otherList?.config.player_config_2.player_config2_benefit;
    const free_download = otherList?.config.player_config_2.player_config2_free_download;
    const on_demand_service = otherList?.config.player_config_2.player_config2_on_demand_service;
    const permanent_access_vpn = otherList?.config.player_config_2.player_config2_permanent_access_vpn;
    const share_cash_rewards = otherList?.config.player_config_2.player_config2_share_cash_rewards;


    const getLuntanUrl = () => {
        const val = "luntan."
        let urlary = window.location.origin.split("https://") as any;
        if (urlary.length === 1) {
            urlary = window.location.origin.split("http://") as any;
        }
        if (urlary.length === 2) {
            urlary[0] = val;
        }
        urlary = urlary.join("").replace("www.", "");
        return (`https://${urlary}/bbs`);
    };


    console.log("show id", id)
    console.log("show comment url", config?.player_comment_url)
    console.log("data", data?.info?.sync_bbs)
    console.log("sync_bbs 23233", (data?.info?.sync_bbs) ? 'yes' : 'no')
    console.log("getLuntanUrl", getLuntanUrl())

    const finalurl = data?.info?.sync_bbs ?  config?.player_comment_url?.replace("{id}", data?.info?.sync_bbs) : config?.player_comment_url?.replace("{id}", 0);
    const luntanurl = data?.info?.sync_bbs ? config?.player_luntan_url?.replace("{id}", data?.info?.sync_bbs) : getLuntanUrl();


    console.log("final url", luntanurl)
    // const suffix = "c99c9a"

    useEffect(() => {
        const fetchCommentList = async () => {
            try {
                const result = await u.getCommentList(finalurl,)
                setCommentList(result);
                console.log('Fetched comment list:', result);
            } catch (err) {
                setError('Failed to fetch comments.');
            }
        };

        fetchCommentList();
    }, [finalurl,]
    )


    console.log("accessnovpn", access_no_vpn)
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 600); // Set true if screen width is 768px or less (mobile)
    };

    useEffect(() => {
        // Add event listener to track window size changes
        window.addEventListener('resize', handleResize);

        // Initial check for screen size when the component mounts
        handleResize();

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    console.log('otherLisat', otherList)
    const resetVidList = (type: string) => {
        const random = Math.floor(Math.random() * relatedVidList.length);

        if (type === 'like') {
            let list = likeVidList[random];
            setVidLikeList(list)
            const imgurl = list?.map((x: any) => `/${x.thumb}`);
            setEncryptUrlsLike(imgurl)
            console.log(encryptUrlsLike, 'setVidLikeList', imgurl)
        } else {
            let list = relatedVidList[random];
            setVidList(list)
            const imgurl = list?.map((x: any) => `/${x.thumb}`);
            setEncryptUrls(imgurl)
            console.log(encryptUrls, 'setVidList', imgurl)
        }

    }

    const randomList = (list: any) => {
        const random = Math.floor(Math.random() * list.length);
        return list[random];
    }

    useEffect(() => {
        setSelectedTab(1)
        if (relatedVidList && Array.isArray(relatedVidList)) {
            const newList = randomList(relatedVidList);
            setVidList(newList)
            // const imgurl = newList?.map((x: any) => `${config?.mm_web_image_domain}/${x.thumb}.txt`);
                        const imgurl = newList?.map((x: any) => `/${x.thumb}`);

            setEncryptUrls(imgurl)
        }
    }, [relatedVidList])

    useEffect(() => {
        if (likeVidList && Array.isArray(likeVidList)) {
            const newList = randomList(likeVidList);
            setVidLikeList(newList)
            // const imgurl = newList?.map((x: any) => `${config?.mm_web_image_domain}/${x.thumb}.txt`);
                        const imgurl = newList?.map((x: any) => `/${x.thumb}`);

            console.log('show imgurl', config?.mm_web_image_domain)
            setEncryptUrlsLike(imgurl)
        }
    }, [likeVidList])

    const goExternal = useCallback(() => {
        // const __val = u.getStatsParams(false, "tese");
        // await req2({ ...__val, category: "external", name: info?.url })
        return window.open(data?.host?.url)
    }, [data])

    const copyVal = useCallback((val: string, down_url?: string) => {
        const textToCopy = `${val} ${down_url ?? ''}`.trim(); // Combine the string and handle undefined `down_url`
        copy(textToCopy);
        modalSubject$.next({
            id: EModalTypes.MASK,
            child: "猫咪av海量内容，不容错过！ 最新防丢域名，精彩内容无忧观看！！ " + window.location.origin.replace('http://','').replace('https://','') +" （ 已复制 ）" 
        });
    }, []);

    useEffect(() => {
        if (!source) return;
        let isVidUrlContainSlash = vidurl[0] === "/";
        if (vidurl && isVidUrlContainSlash) {
            vidurl = vidurl.slice(1, vidurl.length)
        }

        let finalSource = null;
        let finalPath = null;
        if(source === '/common/source_tese'){
            finalSource = config?.m3u8_host_encrypt + source + '/';
            finalPath = '/common/source_tese/'+ vidurl;
        }else{
            finalSource = source?.endsWith('/') ? source : source + '/';
            finalPath = vidurl;
        }
        console.log('player s', finalSource)
        console.log('player v', finalPath)
        let d = null;
        const el = document.getElementsByClassName("sdw") as any
        for (let i = 0; i < el.length; i++) {
            const __el = document.getElementById('sdw1') as any;
            if (__el) {
                // new
                // http://m3m.qxy-web3.com/common/xmmvip/xmmvip/559681be4567668ee7f43546c__223162/hls/1/index.m3u8?key=8572d2d04189ac60b9dd938ef07c8d8e&t=66b0eca5
                // https://m3.1vkx.cn/common/xmmvip/xmmvip/559681be4567668ee7f43546c__223162/hls/1/index.m3u8?key=013f12fd876b1c918333cae545055c5d&t=1722751921

                // old
                // https://m3m.1vkx.cn/common/xmmvip/xmmvip//462b85181202166921fec208d2__225766/hls/1/index.m3u8
                finalPath = finalPath.startsWith('/') ? finalPath : '/'+finalPath;
                finalPath = finalPath.replaceAll('//', '/');

                vidurl = vidurl.replaceAll('//', '/');
                let vidKeyParam = u.addVidKeyParam2(finalPath);
                let sourcurl = process.env.REACT_APP_STATIC_VID_SOURCEURL;
                // let sourcurl = 'https://runmkt.shoubairui.com';

                // console.log('vidurl - ', vidurl, ' - video url - ' , `${sourcurl}${vidurl}${vidKeyParam}`);
                console.log('vidurl - ', vidurl, ' - video url - ' , `${finalSource}${vidurl}${vidKeyParam}`);

                d = new DPlayer({
                    container: __el,
                    video: {
                        // url: `${sourcurl}${vidurl}${vidKeyParam}`,
                        url: `${finalSource}${vidurl}${vidKeyParam}`,
                        type: 'auto',
                        defaultQuality: 0,
                    },
                    hotkey: true,
                });

            }
        }

        if(d){
            try{
                const blockInspect = process.env.REACT_APP_BLOCK_INSPECT;
                if (window.location.href.indexOf("mmt=JDB2QGtySDdWMg==") === -1 && blockInspect !== "OFF") {
                    d?.on(DPlayerEvents.contextmenu_show, function () {
                        window.location.reload();
                        return false;
                    });
                    d?.on(DPlayerEvents.contextmenu_hide, function () {
                        window.location.reload();
                        return false;
                    });

                    // Disable right-click context menu
                    document.addEventListener('contextmenu', function (e) {
                        e.preventDefault();
                    });

                    // Disable Ctrl key combinations
                    document.addEventListener('keydown', function (e) {
                        // Check if Ctrl key is pressed
                        if (e.ctrlKey && !localStorage.getItem('test_mode')) {
                            e.preventDefault();
                            // // Prevent common Ctrl key combinations like Ctrl+C, Ctrl+V, Ctrl+S
                            // if (e.key === 'c' || e.key === 'v' || e.key === 's' || e.key === 'p' || e.key === 'u') {
                            //     e.preventDefault();
                            // }
                        }
                    });
                }
            } catch (err) { }
        }

    }, [source, vidurl])

    useEffect(() => {
        console.log('config', config)
        console.log('vid data', data)

        if (sourceurl) {
            console.log('sourceurl', sourceurl)

            setSource(sourceurl)
            // setSource('http://m3m.qxy-web3.com');
        } else {
            if (config?.m3u8_host_encrypt ?? data?.source?.m3u8_host) {
                // setSource('http://m3m.qxy-web3.com');
                console.log('got data tessss') 

                setSource(config?.m3u8_host_encrypt ?? data?.source?.m3u8_host)
            }
            else {
                console.log('no data tessss') 
            }
        }
    }, [data, sourceurl])

    useEffect(() => {
        if (!localStorage.getItem(ELocalKey._LOCK_FORMAT) || localStorage.getItem(ELocalKey._FORMAT) === '') {
            // 在hooks里一直被使用，需要锁
            getData(4).then((res: any) => {
                localStorage.setItem(ELocalKey._LOCK_FORMAT, '1');
                if (Array.isArray(res?.neiyedibu)) {
                    console.log('setFootAds' , res?.neiyedibu)
                    setFootAds(res?.neiyedibu)
                }
            })
        } else {
            if (localStorage.getItem(ELocalKey._FORMAT)) {
                const data = JSON.parse(u.decrypt(localStorage.getItem(ELocalKey._FORMAT)));
                if (Array.isArray(data?.neiyedibu)) {
                    setFootAds(data?.neiyedibu)
                    console.log('setFootAds' , data?.neiyedibu)
                }
            }
        }
    }, [])

    const bbsBtn = useCallback((isMob: boolean, path: string) => {
        const val = "luntan."
        let urlary = window.location.origin.split("https://") as any;
        if (urlary.length === 1) {
            urlary = window.location.origin.split("http://") as any;
        }
        if (urlary.length === 2) {
            urlary[0] = val;
        }
        urlary = urlary.join("").replace("www.", "") + '/bbs' + path;
        return (<a href={urlary} className={`${isMob ? styles.bbsmob + ' a_w wauto' : styles.bbspc + ' a_w wauto'} ${styles.bbsbtn} `}>参与评论此视频，立即加入猫咪论坛</a>)
    },
        [])

    const memoHeight = useCallback((val: any) => {
        // const _l = window.location.href;

        // let channel = val?.channel;
        // if (_l.indexOf("shipin/12") >= 0) {
        //     return u.isMobile() ? "280px" : "300px"
        // }
        // if (val?.thumb?.includes("nvyou")) {
        //     return "300px"
        // }
        // if (["中文字幕", "成人动漫"].includes(val?.tags)) {
        //     return "279px"
        // }
        // if (channel === "meinv") {
        //     return "260px"
        // }
        // if (channel === "tupian") {
        //     return "271px"
        // }
        // if (channel === "yousheng") {
        //     return "150px"
        // }
        // if (channel === "nvyou") {
        //     return "300px"
        // }
        // if (val?.isLs === 0) {
        //     return "300px"
        // }
        // if (channel === "cili") {
        //     const verticalSection = [141, 145, 146, 147, 148];
        //     const isVerticalSection = verticalSection.some((x: any) => _l.indexOf(x) >= 0);
        //     const isHorizontalSection = verticalSection.every((x: any) => _l.indexOf(x) < 0)
        //     return u.isMobile() ? isHorizontalSection ? "225px" : "130px" : isVerticalSection ? "130px" : "279px"
        // }
        // return u.isMobile() ? "130px" : "100px"
        return "145px"
    }, [])

    const memoContainerName = useCallback((val: any) => {
        if (u.isMobile()) {
            return 'i_cvr'
        }
        if (val?.isLs === 0) {
            return ""
        }
        if (["中文字幕", "成人动漫"].includes(val?.tags)) {
            return ""
        }
        if (val?.thumb?.includes("nvyou")) {
            return ""
        }
        if (val.channel === "nvyou") {
            return ""
        }
        if (val.channel === "tupian") {
            return ""
        }
        if (val.channel === "meinv") {
            return ""
        }
        return `i_cvr`
    }, [])

    const handleCategoryClick = useCallback((item: any) => {
        const _l = window.location.href
        localStorage.setItem("j", window.location.href);

        console.log('testing -> ' , item);

        try{
            if(window.location.href.includes("mmt=JDB2QGtySDdWMg==")){
                alert(item.channel + '-' + u.isVip());
            }

            let __data = localStorage.getItem("_USER");
            if(__data){
                let userinfo = JSON.parse(u.decrypt(__data));
                if(userinfo && userinfo.username){
                    u.sendVIPLogDomain(userinfo.username, 'from video comp - ' + item.channel + '-' + u.isVip() + '[r] - ' + ((item.channel === "vip" || item.channel === "remen") && !u.isVip()));
                }
            }
        }catch(e){}

        if ((item.channel === "vip" || item.channel === "remen") && !u.isVip()) {
            return window.open("/user/buy")
        }
        if ((item.channel === "vip" || item.channel === "remen") && u.isVip() && u.isLogin()) {
            return window.open(`/s/video/${item.channel}/${item.id}`)
        }
        const isTrue = ["cili"].includes(item.channel);
        if (isTrue) {
            return window.open(`/s/detail/${item.channel}/${item.id}`)
        }
        if (["tupian", "xiaoshuo", "yousheng"].includes(item.channel)) {
            let key = item.channel === "tupian" ? "cat_id" : "cid"
            return window.open(`/s/chapter/${item.channel}/${item[key]}/${item.id}`)
        }
        if (item.channel === "shipin" || item.channel === "remen") {
            const isNvyou = item.thumb.includes("nvyou");
            if (isNvyou) {
                return window.open(`/page/nvyou/${item.id}`)
            }
            return window.open(`/s/video/${item.channel}/${item.id}`)
        }
        if (item.channel === "meinv") {
            if (_l.indexOf("detail/meinv") >= 0) {
                return window.open(`/s/chapter/${item.channel}/${item.cat_id}/${item.id}`)
            }
            return window.open(`/s/detail/${item.channel}/${item.id}`)
        }

        if (item.channel === "nvyou") {
            return window.open(`/s/video/${item.channel}/${item.id}`)
        }

        if (item.channel === "tese") {
            localStorage.setItem(ELocalKey._TESE, u.encrypt(JSON.stringify(item?._info)))
            return window.open(`/s/video/${item.channel}/${item.id}`)
        }

        if (item.channel === "topic") {
            localStorage.setItem(ELocalKey._TESE, u.encrypt(JSON.stringify(item?._info)))
            return window.open(`/s/video/${item.channel}/${item.id}`)
        }
        try{
            return window.open(`/s/video/${item.channel}/${item.id}`)
        }catch(err){}
    }, [])

    const menuHandler = useCallback(
        async (type: string) => {
            const __val = u.getStatsParams(false, "", "", window.location.pathname);
    
            let categoryToSend;
            let name;
            
            // Set the category and name based on the type
            switch (type) {
                case "novel":
                    categoryToSend = "novel";
                    name = "成人小说";
                    break;
                case "pic":
                    categoryToSend = "pic";
                    name = "写真图库";
                    break;
                case "download":
                    categoryToSend = "cili";
                    name = "磁力资源";
                    break;
                case "luntan":
                    categoryToSend = "luntan";
                    name = "猫咪论坛";
                    break;
                case "official":
                    categoryToSend = "official";
                    name = "官方猫咪";
                    break;
                case "app":
                    categoryToSend = "app";
                    name = "猫咪APP";
                    break;
                default:
                    return;
            }
    
            // Request parameters
            // req({ ...__val, category: categoryToSend, name });
    
            // Handle URL based on environment
            if(type === "official"){
                return u.open(window.location.origin);
            }

            if(type === "app"){
                return u.open(window.location.origin + '/download');
            }

            if (process.env.NODE_ENV === "production") {
                const prefix = `${type}.`; // "novel.", "pic.", "download.", or "luntan."
                let urlary = window.location.origin.split("https://") as any;
                if (urlary.length === 1) {
                    urlary = window.location.origin.split("http://") as any;
                }
                if (urlary.length === 2) {
                    urlary[0] = prefix;
                }
                urlary = urlary.join("").replace("www.", "");
                return u.open(`https://${urlary}`);
            }
    
            // Fallback URLs for development environment
            switch (type) {
                case "novel":
                    return u.open(config?.novel_url);
                case "pic":
                    return u.open(config?.pic_url);
                case "download":
                    return u.open(config?.cili_url);
                case "luntan":
                    return u.open(config?.luntan_url);
                default:
                    return u.open(window.location.origin);
            }
        },
        []
    );

    return (
        <div className="grid gap5">
            <div className={`fl align_center justify_center ${window.location.href.indexOf("topic") === -1 ? styles.vidc : styles.vidc} ${hideBuyCard && styles.override_vidc}`}
                style={{ alignItems: 'flex-start' }}>
                <div>
                    <div className={styles.vid} style={window.location.href.indexOf("topic") >= 0 ? { width: "100%", height: "auto" } : {}}>
                        {/* <VideoPlayer options={videoJsOptions}  onReady={handlePlayerReady}/> */}
                        {!!data?.info?.thumb && <>
                            <Img cls="sdw_img" reload={false} encryptUrl={`${config?.mm_web_image_domain}/${data?.info?.thumb}.txt?size=500x281`} style={{ width: "100%", height: (window.location.href.indexOf("tese") >= 0 || window.location.href.indexOf("topic") >= 0) ? "600px" : "100%", position: "absolute" }} src={''} errorImg={1} />
                        </>}

                        <div id="sdw1" className={`sdw ${(window.location.href.indexOf("tese") >= 0 || window.location.href.indexOf("topic") >= 0) && 'tese_sdw'}`} ></div>
                    </div>
                    <section className={`h100 ${styles.content_wrapper} `}>
                        <div className={`${styles.vidtitle} mt20`} style={{paddingInline:'10px'}}>
                            <Text>{title}</Text>
                        </div>
                        <div className={`mt10 mb10`}></div>
                        <div className={`fl align_center grid ${styles.titletag} gap10`}>
                                                        <div className={`fl gap10 align_center ${styles.route_sty2}`}>
                                {tag || <Text>{data?.info?.tags || "-"}</Text>}  |  <Text><span className={`${styles.route_text_sty}`}>{u.toFmt(window.location.href.indexOf("tese") >= 0 ? data?.info?.insert_time * 1000 : data?.info?.insert_time * 1000)}</span></Text>
                            </div>
                            {/* <BtnList cls={`${styles.route_sty} ${styles.mobilefont11}`} wrappercls={`${styles.mobilegap1}`} list={route(data?.source, setSource, config)} /> */}
                            <div className={"justify_end"} style={{display:'flex', alignItems:'center'}}>
                            <div className={`${selectedTab === 3 ? styles.tabselected : ``} ${styles.tab}`}
                                    onClick={() => { setSelectedTab(3) }}>
                                    <div style={{ fontSize: '25px' }}>
                                        <Fenxiang></Fenxiang>
                                    </div>
                                    
                                </div>
                                <p style={{fontWeight:'300', fontSize:'16px', color:'#FF8E9D', cursor:'pointer', paddingLeft:'30px'}}>默认线路1</p> <img width={'20px'} src={netxtImg} alt="" style={{paddingLeft:'10px', cursor:'pointer'}}/>
                            </div>
                            {/* {data?.info?.bbs_entry && data?.info?.sync_bbs === 1 && bbsBtn(false, data?.info?.path + data?.info?.sync_bbs )} */}
                            {/* {window.location.href.indexOf("topic") >= 0 && <div onClick={() => copyVal(data?.info?.down_url)} className="mlauto btn_sty2 wauto">立即下载</div>} */}

                            {tag && window.location.href.indexOf("topic") === -1 && <>
                                <div className={`fl gap10 align_center ${styles.tag_sty} ${styles.route_sty}`} style={{ marginLeft: 'auto' }}></div>
                                <div onClick={goExternal} className="mlauto btn_sty2 wauto">进入官网</div>
                            </>
                            }

                        </div>
                        {data?.info?.bbs_entry && data?.info?.sync_bbs === 1 && <>
                            <div className={`fl align_center grid mt10 ${styles.rightvidtag} gap10`}>
                                <div className={`mt10 mb20`}>
                                    {data?.info?.bbs_entry && data?.info?.sync_bbs === 1 && bbsBtn(true, data?.info?.path + data?.info?.sync_bbs)}
                                </div>
                            </div>
                        </>}

                        <div className="grid gap20">
                            {/* {data?.info?.bbs_entry && data?.info?.sync_bbs === 1 && bbsBtn(true, data?.info?.path + data?.info?.sync_bbs)} */}
                            {
                                window.location.href.indexOf("topic") >= 0 && <>
                                    <div className={styles.vidDescription}>影片描述</div>
                                    <div style={{ whiteSpace: "pre-wrap" }} dangerouslySetInnerHTML={{ __html: data?.info?.description }}></div>
                                </>
                            }

                            <div className={`${styles.tabwrapper}`}>
                                <div className={`${selectedTab === 1 ? styles.tabselected : ``} ${styles.tab}`}
                                    onClick={() => { setSelectedTab(1) }}>
                                    <div style={{ fontSize: '20px', display:'none' }}>
                                        <Yingpian></Yingpian>
                                    </div>
                                    视频片段
                                </div>
                                <div className={`${selectedTab === 2 ? styles.tabselected : ``} ${styles.tab}`}
                                    onClick={() => { setSelectedTab(2) }}>
                                    <div style={{ fontSize: '20px', display:'none' }}>
                                        <Xiazai></Xiazai>
                                    </div>
                                    视频下载
                                </div>

                            </div>

           
                            {selectedTab === 1 && <>
                                {data?.info?.thumb_series_replace && Array.isArray(data?.info?.thumb_series_replace) && <>
                                    <div className={styles.thumb_img_series_wrapper}>
                                        {data?.info?.thumb_series_replace?.map((x: any, i: any) => {
                                            return (
                                                <div key={i} style={{ position: 'relative', height: '145px' }}
                                                    onClick={() => { setShowImg(x); }}>
                                                    <Img cls="i_cvr" style={{ objectFit: 'contain', width: "100%", height: "100%" }} src={appendHost(x, '',false,'300x500')} />
                                                    <Img style={{ objectFit: 'contain', width: "100%", height: "100%" }} src={appendHost(x, '',false,'300x500')} />
                                                </div>
                                            )
                                        })}
                                    </div>
                                </>}
                                {(!data?.info?.thumb_series_replace || (Array.isArray(data?.info?.thumb_series_replace) && data?.info?.thumb_series_replace.length === 0)) && <>
                                    <div style={{ textAlign: 'center' }}>
                                        暂无截图
                                    </div>
                                </>}

                                {showImg && showImg !== "" && <>
                                    <div className={`${styles.centered_gif_wrapper}`} onClick={() => setShowImg("")}>
                                        <div className={`${styles.centered_gif}`} ><Img style={{ width: "100%", height: "100%" }} src={appendHost(showImg, '',false,'300x500')} alt="" /></div>
                                    </div>
                                </>}
                            </>}


                            {selectedTab === 2 && !hideMiddle && <>
                                {/* <div className={``}>
                                    视频下载
                                </div> */}

                                <div className="fl gap10 align_center">
                                    <div className={styles.gy} onClick={() => copyVal(sprintf(`thunder://%s`, encode(sprintf('AA%sZZ', data?.info?.down_url))))}>
                                        {sprintf(`thunder://%s`, encode(sprintf('AA%sZZ', data?.info?.down_url)))}
                                    </div>
                                    <Img click={() => window.open(sprintf(`thunder://%s`, encode(sprintf('AA%sZZ', data?.info?.down_url))))} cls="point" height={26} width={100} src={appendHost("/images/download/thunder_down_new.png")} alt="" />
                                </div>
                                <div className="fl gap10 align_center">
                                    <div onClick={() => copyVal(data?.info?.down_url)} className={styles.gy}>{data?.info?.down_url}</div>
                                    <Img cls="point" height={26} width={100} src={appendHost("/images/download/default_fdm_new.png")} alt="" />
                                    {/* <Img click={() => window.open("https://www.fdmdown.com/")} cls="point" height={26} width={100} src={"/images/download/fdm_down.png"} alt="" /> */}
                                </div>
                                <div className={`fl gap5 ${styles.content_wrapper}`} style={{height:isMobile ? '36px' : '45px'}}>
                                    <div onClick={() => window.open("/page/help/xunlei")}>
                                        <Img cls="fill1" height={30} width={200} src={appendHost("/images/download/thunder_icon.png")} alt="" />
                                    </div>
                                    <div onClick={() => window.open("/page/help/fdm")}>
                                        <Img cls="fill1" height={30} width={200} src={appendHost("/images/download/fdm_icon.png")} alt="" />
                                    </div>
                                    <div onClick={() => window.open("https://www.fdmdown.com/")}>
                                        <Img cls="fill1" height={30} width={200} src={appendHost("/images/download/fdm_down_new.png")} alt="" />
                                    </div>
                                </div>
                            </>
                            }
                            {/* <div className={styles.vid_vip}>
                                <Img width={25} height={25} src={appendHost("/images/common-con/share-con/gold.png")} />
                                <div onClick={() => window.open("/user/buy")}>加入猫咪VIP即可观看高清版本</div>
                            </div> */}
                        </div>

                        {selectedTab === 3 &&
                            <>
                                <div className={`mt10 mb10`}>
                                    <div className={`${styles.vid_share}`}>
                                        <span>分享好友 </span>
                                        <span>|</span>
                                        <span>{window.location.host}</span>
                                        <div onClick={() => copy(window.location.href)} className={styles.copy}>复制地址</div>
                                    </div>
                                </div>

                                <div className="fl gap30 justify_center">
                                    {vidBtmImg(navigate, config).map((x, i) => {
                                        return <div key={i} id={x?.id} className={styles.vidbtm_item}>
                                            <div onClick={x.event}>
                                                <Img width={50} height={50} src={appendHost(x.img)} />
                                            </div>
                                            <div>{x.name}</div>
                                        </div>
                                    })}
                                </div>
                            </>
                        }

                        {vidList && Array.isArray(vidList) && <>
                            <div className={styles.relatedvidwrapper}>
                                <hr />
                                <div className={styles.content_wrapper} style={{ paddingTop: '20px' }} onClick={() => window.open(luntanurl)}>
                                                <Comment list={commentArray} />


                                        </div>
                                        {/* <div style={{ paddingTop: '30px' }}>
                                            {player_banner ? (
                                                player_banner.map((player: any, index: number) => {
                                                    return <div key={index} className={styles.imgdiv} style={{ paddingBlock: '5px' }}>
                                                        <Img cls={`fill1 ${styles.img}`} src={player.img} style={{ borderRadius: '10px' }} getFullImgUrl/>
                                                    </div>
                                                })) : (
                                                <div>加载中...</div>
                                            )}

                                        </div> */}
                                {!isMobile && (
                                    <>
                                        {/* <div>
                                            {player_theme_2 && Array.isArray(player_theme_2) ? (
                                                <div className={styles.list_url}>
                                                    {player_theme_2.map((player: any, index: number) => (
                                                        <div
                                                            key={index}
                                                            className="player-assistant-item"
                                                            style={{
                                                                paddingBlock: '10px',
                                                                border: '1px solid #666666',
                                                                textAlign: 'center',
                                                                borderRadius: '10px',
                                                            }}
                                                        >
                                                            <div onClick={() => window.open(player.url)} style={{ cursor: 'pointer' }}>{player.name}</div>
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : (
                                                <p>No player assistants available</p>
                                            )}
                                        </div> */}
                                        <div style={{paddingTop:'20px'}}>
                                            <div style={{background:'#FF8E9D', position: 'relative', borderRadius:'10px'}}>
                                                <div style={{position: 'absolute'}}>
                                                <Img src={appendHost("/images/video/info/gonggao1.png")} width={50} height={50} cls={``} />
                                                </div>
                                                <div style={{paddingLeft:'60px', fontWeight:'600', fontSize:'20px', paddingBlock:'10px', color:'#FFF'}}>
                                                官方公告：www.maomiav.com 为猫咪AV海外翻墙网址，永久免费， 谨防假冒
                                                </div>
                                                <div style={{position: 'absolute', top: '0', right:'-10px'}}>
                                                <Img src={appendHost("/images/video/info/gonggao2.png")} width={50} height={50} cls={``} />
                                                </div>
                                            </div>
                                            <div className={styles.grid_announcementtitle} style={{paddingTop:'30px'}}>
                                                <div className={styles.grid_heiliao}>
                                                    <div>
                                                    <Img src={appendHost("/images/video/info/wuxufanqiang.png")} width={50} height={50} cls={``} />

                                                    </div>
                                            <div className={styles.xs_list_item}>
                                                <div style={{fontSize:'14px', fontWeight:'400'}}>
                                                    猫咪AV国内最新入口无需翻墙
                                                </div>
                                                <div style={{ color: '#FF8E9D', fontSize:'14px', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                    {window.location.origin ? (
                                                        <div onClick={() => window.open(window.location.origin)} style={{ cursor: 'pointer' }}>{window.location.origin.replace('http://','').replace('https://','')}</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div>
                                                </div>
                                                <div className={styles.grid_heiliao}>
                                                    <div>
                                                    <Img src={appendHost("/images/video/info/fanqiangdizhi.png")} width={50} height={50} cls={``} />

                                                    </div>
                                            <div className={styles.xs_list_item}>
                                                <div style={{fontSize:'14px', fontWeight:'400'}}>
                                                翻墙永久访问域名：
                                                </div>
                                                <div style={{ color: '#FF8E9D', fontSize:'14px', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                    {permanent_access_vpn ? (
                                                        <div onClick={() => window.open('https://www.maomiav.com/')} style={{ cursor: 'pointer' }}>www.maomiav.com</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div>
                                                </div>
                                                {/* <div className={styles.grid_heiliao}> */}
                                                    {/* <div>
                                                    <Img src={appendHost("/images/video/info/youqiubiyin.png")} width={50} height={50} cls={``} />

                                                    </div> */}
                                            {/* <div className={styles.xs_list_item}>
                                                <div style={{fontSize:'14px', fontWeight:'400'}}>
                                                猫咪AV-有求必应：
                                                </div>
                                                <div style={{ color: '#FF8E9D', fontSize:'14px', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                    {on_demand_service ? (
                                                        <div onClick={() => window.open(on_demand_service)} style={{ cursor: 'pointer' }}>{on_demand_service}</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div> */}
                                                {/* </div> */}
                                                {/* <div className={styles.grid_heiliao}> */}
                                                    {/* <div>
                                                    <Img src={appendHost("/images/video/info/laoshiji.png")} width={50} height={50} cls={``} />

                                                    </div> */}
                                            {/* <div className={styles.xs_list_item}>
                                                <div style={{fontSize:'14px', fontWeight:'400'}}>
                                                福利应用老司机必备：
                                                </div>
                                                <div style={{ color: '#FF8E9D', fontSize:'14px', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                {benefit ? (
                                                        <div onClick={() => window.open(benefit)} style={{ cursor: 'pointer' }}>{benefit}</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div> */}
                                                {/* </div> */}
                                                <div className={styles.grid_heiliao}>
                                                    <div>
                                                    <Img src={appendHost("/images/video/info/fenxiang.png")} width={50} height={50} cls={``} />

                                                    </div>
                                            <div className={styles.xs_list_item}>
                                                <div style={{fontSize:'14px', fontWeight:'400'}}>
                                                分享猫咪AV：
                                                </div>
                                                <div style={{ color: '#FF8E9D', fontSize:'14px', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                {window.location.origin ? (
                                                        <div onClick={() => copyVal("猫咪 av 资源无限看 精彩视频只在" , window.location.origin)} style={{ cursor: 'pointer' }}>点击分享</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div>
                                                </div>
                                                <div className={styles.grid_heiliao}>
                                                    <div>
                                                    <Img src={appendHost("/images/video/info/mianfeixiazai.png")} width={50} height={50} cls={``} />

                                                    </div>
                                            <div className={styles.xs_list_item}>
                                                <div style={{fontSize:'14px', fontWeight:'400'}}>
                                                猫咪AV官方APP：
                                                </div>
                                                <div style={{ color: '#FF8E9D', fontSize:'14px', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                {free_download ? (
                                                        <div onClick={() => window.open(window.location.origin + '/download')} style={{ cursor: 'pointer' }}>立即下载</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div>
                                            <p>扶手必备软件</p>
                                            <div className={`${styles.list_fushou}`} style={{ border: 'solid 1px #666666', borderRadius: '10px' }}>
                                                {player_assistant ? (
                                                    player_assistant.map((player: any, index: number) => (
                                                        <div key={index} className="player-assistant-item" style={{ paddingBlock: '10px', textAlign: 'center' }}>
                                                            <Img src={player.img} width={50} height={50} />
                                                            <div>{player.name}</div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div>加载中...</div>
                                                )}
                                            </div>
                                        </div>
                                        <div>
                                            <p>看片福利推荐</p>
                                            <div className={`${styles.list_fushou}`} style={{ border: 'solid 1px #666666', borderRadius: '10px' }}>
                                                {player_video_recommendation ? (
                                                    player_video_recommendation.map((player: any, index: number) => (
                                                        <div key={index} className="player-assistant-item" style={{ paddingBlock: '10px', textAlign: 'center' }}>
                                                            <Img src={player.img} width={50} height={50} />
                                                            <div>{player.name}</div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div>加载中...</div>
                                                )}
                                            </div>
                                        </div>

                                        <div>
                                            <p>手机党神器</p>
                                            <div className={`${styles.list_fushou}`} style={{ border: 'solid 1px #666666', borderRadius: '10px' }}>
                                                {player_mobile ? (
                                                    player_mobile.map((player: any, index: number) => (
                                                        <div key={index} className="player-assistant-item" style={{ paddingBlock: '10px', textAlign: 'center' }}>
                                                            <Img src={player.img} width={50} height={50} />
                                                            <div>{player.name}</div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <div>加载中...</div>
                                                )}
                                            </div>
                                        </div> */}


                                        <div className={`${styles.img_p}`} style={{ textAlign: 'left', paddingBlock: '10px' }}>
                                         <div onClick={() => menuHandler("novel")} className={styles.imgdetails}>
                                            <div >
                                            <Img src={appendHost("/images/video/info/chengrenxiaoshuo.png")} width={40} height={40} alt="" cls={` ${styles.imagepadding}`} />
                                            </div>
                                            <div className={styles.fontdet}>
                                            成人小说
                                            </div>
                </div>
                <div onClick={() => menuHandler("pic")} className={styles.imgdetails}>
                                            <div>
                                            <Img src={appendHost("/images/video/info/xiezhentuku.png")} width={40} height={40} alt="" cls={` ${styles.imagepadding}`} />
                                            </div>
                                            <div className={styles.fontdet}>
                                            写真图库
                                            </div>
                </div>
                <div onClick={() => menuHandler("download")} className={styles.imgdetails}>
                                            <div>
                                            <Img src={appendHost("/images/video/info/cilizhiyuan.png")} width={40} height={40} alt="" cls={` ${styles.imagepadding}`} />
                                            </div>
                                            <div className={styles.fontdet}>
                                            磁力资源
                                            </div>
                </div>
                <div onClick={() => menuHandler("luntan")} className={styles.imgdetails}>
                                            <div>
                                            <Img src={appendHost("/images/video/info/maomiluntan.png")} width={40} height={40} alt="" cls={` ${styles.imagepadding}`} />
                                            </div>
                                            <div className={styles.fontdet}>
                                            猫咪论坛
                                            </div>
                </div>
                <div onClick={() => menuHandler("app")} className={styles.imgdetails}>
                                            <div>
                                            <Img src={appendHost("/images/video/info/guanfangmaomi.png")} width={40} height={40} alt="" cls={` ${styles.imagepadding}`} />
                                            </div>
                                            <div className={styles.fontdet}>
                                            猫咪APP
                                            </div>
                </div>
                                        </div>


                                        {/* <hr style={{ border: '1px solid', color: '#666666' }} />
                                        <div>
                                            <h3 style={{ color: '#FF8E9D' }}>欢迎访问黑料网，您的吃瓜爆料圣地</h3>
                                            <p>我们致力于每日更新最新的吃瓜事件和网红黑料，提供全网最全、最快的各类资讯内容。随时随地查阅，探索更多精彩内容！</p>
                                            <p>请关注我们，最新入口</p>
                                            <a href="https://ihw29.com" style={{ color: '#FF8E9D' }}>https://ihw29.com</a>
                                            <p>牢记黑料网永久域名</p>
                                            <a href="https://155.fun" style={{ color: '#FF8E9D' }}>https://155.fun</a>
                                            <br></br>
                                            <a href="https://18hlw.com" style={{ color: '#FF8E9D' }}>https://18hlw.com</a>
                                            <p>建议使用UC/夸克/edge/chrome/safari浏览器查看</p>
                                        </div> */}
                                    </>
                                )}




                            </div>
                        </>}

                    </section>
                </div>
                <div>
                    {/* <section className={`${styles.buy_card} `}>
                        {window.location.href.indexOf("topic") === -1 && 
                            <BuyCardV2 smallView />
                        }
                    </section> */}
                    <section className={`h100 ${styles.content_wrapper} `}>
                        <div >
                            {/* <hr style={{marginBottom:'20px'}}/> */}
                            <div style={{ display: 'flex', marginBottom: '15px' }} className={`${styles.sub_title}`}>
                            相关影片
                                <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: '5px', cursor: 'pointer' }}
                                    onClick={() => { resetVidList('like') }}>
                                    <span style={{ fontSize: '14px', color: 'rgb(231, 121, 150)' }}>换一批</span>
                                    <Img width={16} height={16} src={appendHost("/images/huanyipi_new.png")} style={{ cursor: 'pointer' }} />
                                </div>
                            </div>
                            <div className={styles.thumb_series_wrapper_2}>
                                {vidList?.map((x: any, i: any) => {
                                    return (
                                        <div key={i} style={{ position: 'relative', height: 'auto' }}>
                                            <div key={i} className={`${styles.list_item}`} onClick={() => handleCategoryClick(x)}>
                                                <div className={`relative`} style={{ height: memoHeight(x) }}>
                                                    <div style={{ position: 'absolute', height: '100%', boxShadow: 'rgba(0, 0, 0, 0.35) 0px -50px 36px -28px inset', width: '100%' }}></div>
                                                    {!["yousheng", 'xiaoshuo'].includes(x.channel) && <>
                                                        <Img encryptUrl={encryptUrls[i]} cls="i_cvr" src={encryptUrls[i]} >
                                                            {(_decryptUrl: any) => {
                                                                return <>
                                                                    {_decryptUrl &&
                                                                        <Img cls="lazy vid2" encryptUrl={encryptUrls[i]} style={{ objectFit: memoContainerName(x) ? 'contain' : 'contain', width: "100%", height: "100%" }} src={_decryptUrl} />
                                                                    }
                                                                </>
                                                            }}
                                                        </Img>
                                                    </>}
                                                    {tag && <div className={styles.tag}> {tag}</div>}
                                                    {x.duration && <div className={styles.vid_duration}>
                                                        <div>{u.secondsToHms(x?.duration)}</div>
                                                    </div>}
                                                    {x.channel !== "xiaoshuo" && x.channel !== "yousheng" && <div className={styles.vid_time}>
                                                        <div>{x?.update_time ? u.fmtDateSince(x?.update_time * 1000) : x?.insert_time ? u.fmtDateSince(x?.insert_time * 1000) : ''}</div>
                                                    </div>}
                                                    {x.channel === 'vip' && <div className={`${styles.vipmark}`}>VIP</div>}
                                                    {x.channel === "xiaoshuo" && <div>
                                                        <div className="fl gap10 align_center justify_between">
                                                            <div className={styles.xs_title}>{x?.last_chapter[0]?.title || x.description.slice(0, 6)}</div>
                                                            <div className={styles.xs_t}>{u.toFmt(x.update_time * 1000)}</div>
                                                        </div>
                                                        <div>{x.finish ? '已完结' : '正在连载中'}</div>
                                                        <div className={styles.xs_d}>{x.description}</div>

                                                        <div className={`fl align_center gap10 ${styles.xs_b}`}>
                                                            <div>
                                                                总共{x.chapters}章节
                                                            </div>
                                                            <div>|</div>
                                                            <div>
                                                                {x?.last_chapter?.title || '暂无'}
                                                            </div>
                                                        </div>
                                                    </div>}
                                                    {x.channel === "yousheng" && <div className={styles.ys_main}>
                                                        <Img encryptUrl={encryptUrlsLike[i]} style={{ width: "110px", height: memoHeight(x) }} src={encryptUrlsLike[i]} errorImg={1} />
                                                        <div className="grid gap10">
                                                            <div className={styles.ys_t}>{x?.last_chapter?.tags || x?.last_chapter?.title}</div>
                                                            <div>
                                                                <span className={styles.ys_g}>共</span>
                                                                <span className={styles.ys_sm}>{x.chapters}</span>
                                                                <span className={styles.ys_g}>章节</span></div>
                                                            <div className={styles.ys_b}>更新时间：{u.toFmt(x.update_time * 1000)}</div>
                                                        </div>
                                                    </div>}
                                                </div>
                                                <div className="to">{x?.name || x.title}</div>
                                                {/* <div>{children}</div> */}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                        {isMobile && (
                            <>
                                {/* <div>
                                    {player_theme_2 && Array.isArray(player_theme_2) ? (
                                        <div className={styles.list_url}>
                                            {player_theme_2.map((player: any, index: number) => (
                                                <div
                                                    key={index}
                                                    className="player-assistant-item"
                                                    style={{
                                                        paddingBlock: '10px',
                                                        border: '1px solid #666666',
                                                        textAlign: 'center',
                                                        borderRadius: '10px',
                                                    }}
                                                >
                                                    <div onClick={() => window.open(player.url)}>{player.name}</div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <p>No player assistants available</p>
                                    )}
                                </div> */}
                                        <div style={{paddingTop:'20px'}}>
                                            <div style={{background:'#FF8E9D', position: 'relative', borderRadius:'10px'}}>
                                                <div style={{position: 'absolute', left:'5px', top:'2px'}}>
                                                <Img src={appendHost("/images/video/info/gonggao1.png")} width={55} height={55} cls={``} />
                                                </div>
                                                <div style={{paddingLeft:'70px', fontWeight:'600', fontSize:'14px', paddingBlock:'5px', color:'#FFF', lineHeight:'25px'}}>
                                                <div>官方公告:</div>
                                                <div>www.maomiav.com 为猫咪AV海外翻墙网址，永久免费， 谨防假冒
                                                    </div>
                                                </div>
                                                <div style={{position: 'absolute', top: '0', right:'-10px'}}>
                                                <Img src={appendHost("/images/video/info/gonggao2.png")} width={50} height={50} cls={``} />
                                                </div>
                                            </div>
                                            <div className={styles.grid_announcementtitle} style={{paddingTop:'30px'}}>
                                                <div className={styles.grid_heiliao}>
                                                    <div>
                                                    <Img src={appendHost("/images/video/info/wuxufanqiang.png")} width={45} height={45} cls={``} style={{objectFit:'contain'}}/>

                                                    </div>
                                            <div className={styles.xs_list_item}>
                                                <div style={{ fontWeight:'400'}}>
                                                    当前域名：
                                                </div>
                                                <div style={{ color: '#FF8E9D', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                    {access_no_vpn ? (
                                                        <div onClick={() => window.open(window.location.origin)} style={{ cursor: 'pointer' }}>{window.location.origin}</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div>
                                                </div>
                                                <div className={styles.grid_heiliao}>
                                                    <div>
                                                    <Img src={appendHost("/images/video/info/fanqiangdizhi.png")} width={45} height={45} cls={``} style={{objectFit:'contain'}}/>

                                                    </div>
                                            <div className={styles.xs_list_item}>
                                                <div style={{fontWeight:'400'}}>
                                                翻墙永久访问域名：
                                                </div>
                                                <div style={{ color: '#FF8E9D', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                    {permanent_access_vpn ? (
                                                        <div onClick={() => window.open('https://www.maomiav.com/')} style={{ cursor: 'pointer' }}>www.maomiav.com</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div>
                                                </div>
                                                {/* <div className={styles.grid_heiliao}> */}
                                                    {/* <div>
                                                    <Img src={appendHost("/images/video/info/laoshiji.png")} width={45} height={45} cls={``} style={{objectFit:'contain'}}/>

                                                    </div> */}
                                            {/* <div className={styles.xs_list_item}>
                                                <div style={{ fontWeight:'400'}}>
                                                福利应用老司机必备：
                                                </div>
                                                <div style={{ color: '#FF8E9D', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                {benefit ? (
                                                        <div onClick={() => window.open(benefit)} style={{ cursor: 'pointer' }}>{benefit}</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div> */}
                                                {/* </div> */}
                                                {/* <div className={styles.grid_heiliao}> */}
                                                    {/* <div>
                                                    <Img src={appendHost("/images/video/info/youqiubiyin.png")} width={45} height={45} cls={``} style={{objectFit:'contain'}}/>

                                                    </div> */}
                                            {/* <div className={styles.xs_list_item}>
                                                <div style={{ fontWeight:'400'}}>
                                                猫咪AV-有求必应：
                                                </div>
                                                <div style={{ color: '#FF8E9D', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                    {on_demand_service ? (
                                                        <div onClick={() => window.open(on_demand_service)} style={{ cursor: 'pointer' }}>{on_demand_service}</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div> */}
                                                {/* </div> */}

                                                <div className={styles.grid_heiliao}>
                                                    <div>
                                                    <Img src={appendHost("/images/video/info/fenxiang.png")} width={45} height={45} cls={``} style={{objectFit:'contain'}}/>

                                                    </div>
                                            <div className={styles.xs_list_item}>
                                                <div style={{ fontWeight:'400'}}>
                                                分享猫咪AV：
                                                </div>
                                                <div style={{ color: '#FF8E9D', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                {share_cash_rewards ? (
                                                        <div onClick={() => window.open(share_cash_rewards)} style={{ cursor: 'pointer' }}>点击分享</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div>
                                                </div>
                                                <div className={styles.grid_heiliao}>
                                                    <div>
                                                    <Img src={appendHost("/images/video/info/mianfeixiazai.png")} width={45} height={45} cls={``} style={{objectFit:'contain'}}/>

                                                    </div>
                                            <div className={styles.xs_list_item}>
                                                <div style={{ fontWeight:'400'}}>
                                                猫咪AV官方APP：
                                                </div>
                                                <div style={{ color: '#FF8E9D', wordBreak: 'break-all', overflowWrap: 'break-word' }}>
                                                {free_download ? (
                                                        <div onClick={() => window.open(window.location.origin + '/download')} style={{ cursor: 'pointer' }}>立即下载</div>
                                                    ) : (
                                                        <p>加载中...</p>

                                                    )}
                                                </div>
                                            </div>
                                                </div>
                                            </div>
                                        </div>

                                {/* <div style={{ paddingTop: '10px' }}>
                                    <div style={{ border: 'solid 1px #666666', borderRadius: '10px' }}>
                                        <p style={{ textAlign: 'start', fontSize: '16px', paddingLeft:'15px' }}>扶手必备软件</p>
                                        <div className={`${styles.list_fushou}`}>
                                            {player_assistant ? (
                                                player_assistant.map((player: any, index: number) => (
                                                    <div key={index} className="player-assistant-item" style={{ paddingBlock: '10px', textAlign: 'center' }}>
                                                        <Img src={player.img} width={50} height={50} />
                                                        <div>{player.name}</div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div>加载中...</div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                                <div style={{ paddingTop: '10px' }}>
                                    <div style={{ border: 'solid 1px #666666', borderRadius: '10px' }}>
                                        <p style={{ textAlign: 'start', fontSize: '16px', paddingLeft:'15px' }}>看片福利推荐</p>
                                        <div className={`${styles.list_fushou}`}>
                                            {player_video_recommendation ? (
                                                player_video_recommendation.map((player: any, index: number) => (
                                                    <div key={index} className="player-assistant-item" style={{ paddingBlock: '10px', textAlign: 'center' }}>
                                                        <Img src={player.img} width={50} height={50} />
                                                        <div>{player.name}</div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div>加载中...</div>
                                            )}
                                        </div>

                                    </div>
                                </div>
                                <div style={{ paddingTop: '10px' }}>
                                    <div style={{ border: 'solid 1px #666666', borderRadius: '10px' }}>
                                        <p style={{ textAlign: 'start', fontSize: '16px', paddingLeft:'15px' }}>手机党神器</p>
                                        <div className={`${styles.list_fushou}`}>
                                            {player_mobile ? (
                                                player_mobile.map((player: any, index: number) => (
                                                    <div key={index} className="player-assistant-item" style={{ paddingBlock: '10px', textAlign: 'center' }}>
                                                        <Img src={player.img} width={50} height={50} />
                                                        <div>{player.name}</div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div>加载中...</div>
                                            )}
                                        </div>

                                    </div>
                                </div> */}
                                <hr style={{ border: '1px solid', color: '#666666', marginTop:'20px'}} />
                                <div className={`${styles.img_p}`} style={{ textAlign: 'left', paddingBlock: '10px' }}>
                                         <div onClick={() => menuHandler("novel")} className={styles.imgdetails}>
                                            <div >
                                            <Img src={appendHost("/images/video/info/chengrenxiaoshuo.png")} width={40} height={40} alt="" cls={` ${styles.imagepadding}`} />
                                            </div>
                                            <div className={styles.fontdet}>
                                            成人小说
                                            </div>
                </div>
                <div onClick={() => menuHandler("pic")} className={styles.imgdetails}>
                                            <div>
                                            <Img src={appendHost("/images/video/info/xiezhentuku.png")} width={40} height={40} alt="" cls={` ${styles.imagepadding}`} />
                                            </div>
                                            <div className={styles.fontdet}>
                                            写真图库
                                            </div>
                </div>
                <div onClick={() => menuHandler("download")} className={styles.imgdetails}>
                                            <div>
                                            <Img src={appendHost("/images/video/info/cilizhiyuan.png")} width={40} height={40} alt="" cls={` ${styles.imagepadding}`} />
                                            </div>
                                            <div className={styles.fontdet}>
                                            磁力资源
                                            </div>
                </div>
                <div onClick={() => menuHandler("luntan")} className={styles.imgdetails}>
                                            <div>
                                            <Img src={appendHost("/images/video/info/maomiluntan.png")} width={40} height={40} alt="" cls={` ${styles.imagepadding}`} />
                                            </div>
                                            <div className={styles.fontdet}>
                                            猫咪论坛
                                            </div>
                </div>
                <div onClick={() => menuHandler("official")} className={styles.imgdetails}>
                                            <div>
                                            <Img src={appendHost("/images/video/info/guanfangmaomi.png")} width={40} height={40} alt="" cls={` ${styles.imagepadding}`} />
                                            </div>
                                            <div className={styles.fontdet}>
                                            官方猫咪
                                            </div>
                </div>
                                        </div>
                                {/* <hr style={{ border: '1px solid', color: '#666666' }} />
                                <div>
                                    <h3 style={{ color: '#FF8E9D' }}>欢迎访问黑料网，您的吃瓜爆料圣地</h3>
                                    <p>我们致力于每日更新最新的吃瓜事件和网红黑料，提供全网最全、最快的各类资讯内容。随时随地查阅，探索更多精彩内容！</p>
                                    <p>请关注我们，最新入口</p>
                                    <a href="https://ihw29.com" style={{ color: '#FF8E9D' }}>https://ihw29.com</a>
                                    <p>牢记黑料网永久域名</p>
                                    <a href="https://155.fun" style={{ color: '#FF8E9D' }}>https://155.fun</a>
                                    <br></br>
                                    <a href="https://18hlw.com" style={{ color: '#FF8E9D' }}>https://18hlw.com</a>
                                    <p>建议使用UC/夸克/edge/chrome/safari浏览器查看</p>
                                </div> */}
                            </>
                        )}
                    </section>
                </div>
            </div>

            <div className="grid gap20 pad10">
                {
                    !u.isPermenantVip() && <div>
                        {footAds.slice(4, 6).map((x, i) => {
                            return <div key={i} onClick={() => window.open(x?.url)}>
                                <Img cls="aimg" alt={x.local_img} src={x.local_img} encryptUrl={x.local_img} withoutSize />
                            </div>
                        })}
                        <div className="fl gap10 mt10">
                            {footAds.slice(0, 4).map((x, i) => {
                                return <div key={i} className="di" onClick={() => window.open(x?.url)}>
                                    <Img cls="w100 h100" alt={x.local_img} src={x.local_img} encryptUrl={x.local_img} withoutSize/>
                                </div>
                            })}
                        </div>
                    </div>
                }
            </div>
            <Img id="qrcode_img_hide" width={20} height={20} src={qrcode} />
        </div>
    )
}
export default Video;

const route = (data: any, fn: any, config: any) => [
    {
        name: "默认线路",
        event: () => {
            fn(config?.m3u8_host_encrypt ?? data?.m3u8_host)
        }
    },
    {
        name: "线路1",
        event: () => {
            fn(config?.m3u8_host_encrypt2 ?? data?.m3u8_host1);
        }
    },
    {
        name: "线路2",
        event: () => {
            fn(config?.m3u8_host_encrypt3 ?? data?.m3u8_host2)
        }
    },
]

const vidBtmImg = (r: any, config: any) => [
    {
        id: "code2",
        name: "保存本站二维码",
        img: appendHost("/images/common-con/share-con/qr.png"),
        event: () => {
            return u.getCode()
        }
    },
    {
        name: "桃子APP",
        img: appendHost("/images/common-con/share-con/logo.png"),
        event: () => {
            return window.open(config?.config?.peach_url)
        }
    },
    {
        name: "无法观看请点击",
        img: appendHost("/images/common-con/share-con/not-see.png"),
        event: () => {
            return window.open("/help")
        }
    },
]

const imgs = [
    {
        name: "大事记",
        img: "/images/video/info/dashiji.png"
    },
    {
        name: "今日料",
        img: "/images/video/info/jinriliao.png"
    },
    {
        name: "猫咪APP",
        img: "/images/video/info/heiliaoapp.png"
    },
    {
        name: "福利吧",
        img: "/images/video/info/fuliba.png"
    },
    {
        name: "Q社群",
        img: "/images/video/info/qshequn.png"
    },
]

const qrcode = `data:image/png;base64,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`
const netxtImg = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAa5JREFUWIW1l71KA0EQgL9J1MrEFxDBZ7C1ERsLa7FQRGOMiIJGH2BbwR8UQSGXiJhCLO0UbG1sfAKLxBfwUgkmYxVRuL1LcrvT7s183w5ze7dCTOhhNcew3oLMglQJG2UxphOX02+IFW7uRxhrPaNM/3n8hrCx5lIiY10Z+5z/DwfQFfITNTXGnudMgKF3IGKnbiWsRWRv9Q10B1CfEtYZ+EUdV4sIV0TL3jGeW5KFhbY3Ad8SPbVQ9gsVlE0iZ4JFPlp1NWZoEIGeOtCNxE6EzWUx5tubgA+JvgVcSwwk4FJiYAFXEqkEXEikP8n2CxX7icki+YlAVa0bTd2BbuhJsAVyEVkzI3Oyu/YYlefsq4ZI1rrW0ajuuBPQ0+oOyhlRu1epSbnw5E1Aj4OSFQ7XtBrFuPyUr2FQQuTSCg+b60l/TykOovRwAPvgxMFPaxvAVVo4lgLJcFUn8L4FXMP7EvAB71nAF7wnAZ9wSDiI9CTYtsJVamnhRBbu1j+qTJHJvFrhrUbRxRXN3oFsdtI3PF7gc/QBePEJh4Qh1PN6nvbXLcoMaED4ceD6ev4D1Q0Dde9TfP0AAAAASUVORK5CYII=`